import styles from "./AnalyticsTrend.module.scss";
import Badge from "../../xepp/badge/Badge";
import { BlackTriangleUp, TriangleDownIcon } from "../../../../assets/icons";

export type AnalyticsTrendDirection = "up" | "down";
export type AnalyticsTrendTone = "positive" | "negative";

type Props = {
	/** Rendered as given — the unit belongs to the metric, e.g. "6.2%", "2pt", "8s". */
	value: string;
	direction: AnalyticsTrendDirection;
	/**
	 * Colour of the badge, for metrics where the arrow alone misleads: a fall in
	 * "Paid · no token" is good news, so it reads down but positive. Defaults to
	 * the direction. The inline variant is always muted and ignores it.
	 */
	tone?: AnalyticsTrendTone;
	/** Trailing text of the inline variant, e.g. "vs prior". Unused by the badge. */
	caption?: string;
	variant?: "inline" | "badge";
};

/**
 * The period-over-period change of a metric, in the two presentations the cards
 * use: a muted line under the value, or a coloured pill beside the label.
 */
const AnalyticsTrend = ({ value, direction, tone, caption, variant = "inline" }: Readonly<Props>) => {
	const icon = direction === "up" ? <BlackTriangleUp /> : <TriangleDownIcon />;

	if (variant === "badge") {
		const resolvedTone = tone ?? (direction === "up" ? "positive" : "negative");

		return (
			<Badge variant={resolvedTone === "positive" ? "active" : "failed"} className={styles.badge}>
				{icon}
				{value}
			</Badge>
		);
	}

	return (
		<span className={styles.inline}>
			{icon}
			{caption ? `${value} ${caption}` : value}
		</span>
	);
};

export default AnalyticsTrend;
